// src/lib/opportunity/formatCurrency.ts
//
// USD currency formatter for the Opportunity Engine UI. Centralized so
// the list view, the live pricing totals, the revisions list, and the
// generated proposal PDF (Slice 4) all render numbers the same way.
//
// Falls back to a hand-rolled $X,XXX.XX format if Intl is unavailable
// (defensive — older test environments / SSR).

const FORMATTER = (() => {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } catch {
    return null;
  }
})();

export function formatOpportunityCurrency(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "$0.00";
  if (FORMATTER) return FORMATTER.format(n);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const fixed = abs.toFixed(2);
  const [intPart, decPart] = fixed.split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}$${withCommas}.${decPart}`;
}

export function formatOpportunityPct(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "0%";
  return `${n}%`;
}
